import React, { useRef, useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useForm, Controller } from 'react-hook-form';
import {
  GET_CITIES,
  API_DOCUMENT_TYPE_COUNTRIES,
  API_GET_NAME_SCHEDULER,
  API_REGISTER_USERS,
  API_ENROLLMENT_VALIDATION_REGISTER,
  API_MEMBERSHIPS_SCHEDULERS_ENABLE
} from '../../../Domain/Redux/Paths';
import LoadingOverlay from 'react-loading-overlay';
import { HttpClient } from '../../../Domain/Utils/ApiUtilies/Fetch/Fetch';
import {
  DIV_LIMIT_FILE,
  ID_SYSTEM_INFORMATION,
  SERVICES_FORMS,
  TYPE_FETCH_PARAMETERS,
  VARIABLES_ID
} from '../../../Domain/Settings/Constants/Constants';
import { Row, Col, Form } from 'react-bootstrap';
import { SelectFormControl } from '../../Atoms/SelectFormControl/SelectFormControl';
import { InputFormControl } from '../../Atoms/InputFormControl/InputFormControl';
import { useGetIdLanguage } from '../../../Core/Hooks/HookLanguageSelector/useGetIdLnaguage';
import Spinner from '../../Atoms/Spinner/Spinner';
import InfoErrorCode from '../../Atoms/InfoErrorCode/InfoErrorCode';
import './userRegisterForm.css';
import SpinnerMiddleware from '../../Atoms/SpinnerMiddleware/SpinnerMiddleware';
import Select from 'react-select';
import { getformatedDateNoLetters } from '../../../Domain/Utils/DateUtilities/DateUtilities';
import 'react-datepicker/dist/react-datepicker.css';
import { Table } from 'react-bootstrap';
import CustomCheck from '../../Atoms/CustomCheck/CustomCheck';
import { TableHeader } from '../../Atoms/TableHeader/TableHeader';
import MessageError from '../../Atoms/MessageError/MessageError';
import AccountVerification from '../../Molecules/AccountVerification/AccountVerification';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';
import { useCountries } from '../../../Core/Hooks/HookGetCountries/useCountriesList';
import useGetReferenceTypeList from '../../../Core/Hooks/HookReferenceType/useReferenceType';
import { useGetVariableField } from '../../../Core/Hooks/HookGetVariablesFields/useGetVariableField';
import useFormProperties from '../../../Core/Hooks/HookFormProperties/useFormProperties';
import { transformData } from '../../../Domain/Utils/TextUtilities/textUtilities';
import ReferenceForm from '../ReferenceForm/ReferenceForm';
import ReferenceTable from '../ReferenceTable/ReferenceTable';

const USER_CREATE = 'User created';

const selectStyles = {
  control: (styles) => ({
    ...styles,
    border: 'none',
    borderBottom: '1px solid #ced4da'
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    color: 'black',
    backgroundColor: isSelected ? '#eee' : 'white'
  }),
  singleValue: (styles) => ({ ...styles, color: '#000' })
};

const selectCustomStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: '1px dotted #ddd',
    color: state.isSelected ? '#000' : '#333',
    padding: 5,
    backgroundColor: state.isSelected ? '#eee' : 'transparent'
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition };
  },
  control: (provided, state) => ({
    ...provided,
    border: 'none',
    borderRadius: 0,
    borderBottom: '1px solid #ddd'
  })
};

export const UserRegisterForm = ({
  onSubmit,
  setNameForm,
  nameForm,
  limitSize = 3000000,
  schedulerIdCourse,
  loaderForm,
  setLoaderForm,
  messageError = '',
  setMessageError = () => { }
}) => {
  const inputFile = useRef(null);
  const countryDocumentUser = useRef(null);
  const [formValues, setFormValues] = useState([]);
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  const [typeFile, setTypeFile] = useState('');
  const [activeFileName, setActiveFileName] = useState(false);
  const [errorEmptyFile, setErrorEmptyFile] = useState('');
  const [errorInvalidFile, setErrorInvalidFile] = useState(false);
  const [errorInvalidSize, setErrorInvalidSize] = useState(false);
  const [loadFile, setLoadFile] = useState(false);
  const [nextPage, setNextPage] = useState(1);
  const [documentTypeList, setDocumentTypeList] = useState([]);
  const [country, setCountry] = useState(null);
  const [countryDocument, setCountryDocument] = useState(null);
  const [citiesList, setCitiesList] = useState([]);
  const [citiesListDoc, setCitiesListDoc] = useState([]);
  const [city, setCity] = useState('');
  const [cityDocument, setCityDocument] = useState(null);
  const [referenceList, setReferenceList] = useState([]);
  const [checkedRefs, setCheckedRefs] = useState(
    referenceList?.map((ref) => ({ id: ref.id, checked: false }))
  );
  const [getCountryData, setCountryData] = useState([]);
  const [nameScheduler, setNameScheduler] = useState('');
  const [userRequiredCredit, setUserRequiredCredit] = useState({ value: false, label: 'No' });
  const [isReference, setIsReference] = useState(false);
  const [errorSchedulerId, setErrorSchedulerId] = useState(false);
  const [idScheduler, setIdScheduler] = useState();
  const [countryPhoneNumberValue, setCountryPhoneNumberValue] = useState(null);
  const [secondForm, setSecondForm] = useState(false);
  const [checkedTruthfulness, setCheckedTruthfulness] = useState(false);
  const [isActiveModal, setIsActiveModal] = useState(false);
  const [empyCheck, setEmpyCheck] = useState(false);
  const [userId, setUserId] = useState(null);
  const [errorSameReference, setErrorSameReference] = useState({ show: false, message: null });
  const [documentTypeForm, setDocumentType] = useState({});
  const [membershiList, setMembershiList] = useState([]);
  const [selectedRef, setSelectedRef] = useState(null);

  const parametersFormInscriptionMlt = useGetComponentParameters(COMPONENTS.FORM_INSCRIPTION);
  const parametersFormInscriptionStd = useGetComponentParametersSingle(
    COMPONENTS.FORM_INSCRIPTION,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parametersFormInscriptionDetail = useGetComponentParametersSingle(
    COMPONENTS.FORM_INSCRIPTION,
    TYPE_FETCH_PARAMETERS.DETAIL
  );
  const parameters = useCombinedObjects(
    parametersFormInscriptionMlt,
    parametersFormInscriptionStd,
    parametersFormInscriptionDetail
  );

  const language = useGetIdLanguage();

  const { countriesList, alpha2codeCountries, phoneTypeList } = useCountries();

  const { variables } = useGetVariableField(SERVICES_FORMS.MY_PROFILE_ENROLLMENT);
  const { getProperty } = useFormProperties(variables);
  const residenceAddressField = getProperty(SERVICES_FORMS.FORM_RESIDENCE_ADDRESS);
  const companyField = getProperty(SERVICES_FORMS.FORM_COMPANY);
  const positionField = getProperty(SERVICES_FORMS.FORM_POSITION);

  const { referenceTypeList } = useGetReferenceTypeList();

  const {
    handleSubmit,
    errors,
    control,
    watch, // <--- 'watch' se extrae aquí
    getValues,
    setValue,
    register,
    setError,
    clearErrors
  } = useForm({
    mode: 'onChange'
  });


  const handleErrorsForm = () => {
    if (nextPage === 2) {
      const validateCountry = country?.pk ?? country?.id;
      if (!validateCountry) {
        // setErrorForm((prev) => ({ ...prev, countryResidence: true }));
        setError('country', {
          type: 'required',
          message: parameters?.RQD_MSG_8?.value
        });
      }
      const validateCity = city?.pk ?? city?.id;
      if (!validateCity) {
        // setErrorForm((prev) => ({ ...prev, cityResidence: true }));
        setError('city', {
          type: 'required',
          message: parameters?.RQD_MSG_8?.value
        });
      }
    }
    if (nextPage === 3) {
      if (!documentTypeForm?.pk || !documentTypeForm?.id) {
        // setErrorForm((prev) => ({ ...prev, cityResidence: true }));
        setError('documentType', {
          type: 'required',
          message: parameters?.RQD_MSG_8?.value
        });
      }
    }
  };
  const fetchMembershiEnablesRole = async (schedulerIdCourse) => {
    if (!schedulerIdCourse) {
      setMembershiList([]);
      setValue('SchedulerMembershipPrice', null);
      return;
    }

    try {
      const data = await HttpClient.GET(API_MEMBERSHIPS_SCHEDULERS_ENABLE, {
        scheduler_id: schedulerIdCourse,
      });

      console.log('DATA LLEGÓ DE LA API:', data); // <-- Verifica esto

      setMembershiList(data);
    } catch (error) {
      console.error('Error fetching membership roles:', error);
      setMembershiList([]);
    }
  };

  // <-- 3. USAR useEffect CON LA DEPENDENCIA CORRECTA
  useEffect(() => {
    if (schedulerIdCourse) {
      fetchMembershiEnablesRole(schedulerIdCourse);
    } else {
      setMembershiList([]);
      setValue('SchedulerMembershipPrice', null);
    }
  }, [schedulerIdCourse]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      handleErrorsForm();
    }
  }, [errors]);

  useEffect(() => {
    // 1. Se activa solo cuando la lista de membresías cambia y estamos en el paso 1
    if (nextPage === 1 && membershiList.length > 0 && formValues?.SchedulerMembershipPrice) {
      const membershipToRestore = membershiList.find(
        (membership) => membership.id === formValues.SchedulerMembershipPrice.id
      );
      // 3. Si la encontramos, la establecemos en el formulario
      if (membershipToRestore) {
        setValue('SchedulerMembershipPrice', membershipToRestore, { shouldValidate: true });
      }
    }
  }, [membershiList, nextPage]); // Se ejecuta cuando la lista de membresías o la página cambian


  useEffect(() => {
    setValue('country', country?.pk !== '' ? country : '');
    setValue('city', '');

    if (country?.pk !== undefined)
      HttpClient.GET(GET_CITIES, { country_id: country.pk }).then((cities) =>
        setCitiesList(cities.results || [])
      );
  }, [country]);

  useEffect(() => {
    setValue('countryDocument', countryDocument);
    setValue('documentCity', '');

    if (countryDocument?.pk !== undefined)
      HttpClient.GET(GET_CITIES, { country_id: countryDocument.pk }).then((cities) =>
        setCitiesListDoc(cities.results || [])
      );
  }, [countryDocument, getValues('countryDocument')]);

  useEffect(() => {
    setValue('city', city);
  }, [city]);

  useEffect(() => {
    setValue('cityDocument', cityDocument);
  }, [cityDocument]);

  useEffect(() => {
    if (formValues?.phone_type?.id) {
      setValue('phone_type', formValues?.phone_type);
    }
  }, [formValues?.phone_type]);

  useEffect(() => {
    if (citiesListDoc?.length > 0 && formValues.cityDocument) {
      const pkCityDocument = formValues?.cityDocument?.pk ?? formValues?.cityDocument;
      const cityDocument = citiesListDoc?.find((city) => city.pk === pkCityDocument);
      setCityDocument(cityDocument ?? cityDocument?.[0]);
      setFormValues((prev) => ({ ...prev, cityDocument }));
    }
  }, [citiesListDoc, formValues?.countryDocument]);

  //get form 1
  const handleDataForm = () => {
    setMessageError('');
    if (nextPage === 1) {
      if (formValues?.first_name) setValue('first_name', formValues?.first_name);
      if (formValues?.last_name) setValue('last_name', formValues?.last_name);
      if (formValues?.schedulerId > 0 || idScheduler > 0)
        setValue('schedulerId', formValues?.schedulerId ?? idScheduler);
      if (formValues?.email) setValue('email', formValues?.email);
      setSecondForm(false);
    }
  };

  const handleReferenceSelection = (ref) => {
    setCheckedReferenceId(ref.id);
    // También guardamos el id en formValues para cuando se envíe el formulario.
    setFormValues((prev) => ({ ...prev, selectReference: ref.id }));
  };
  const [checkedReferenceId, setCheckedReferenceId] = useState(null);


  useEffect(() => {
    handleDataForm();
  }, [nextPage, formValues, schedulerIdCourse, isActiveModal]);

  //TODO: can refactor
  useEffect(() => {
    //get form 2
    if (nextPage === 2 || secondForm) {
      setMessageError('');
      if (formValues?.phoneNumber) setValue('phoneNumber', formValues?.phoneNumber);

      const idCountryPhone = formValues?.country_code;

      const matchedCountry = alpha2codeCountries.find((country) => {
        const dialCode = `${country.dial_code}`.trim();
        const pk = `${country.pk}`;
        const input = `${idCountryPhone}`.trim();
        return dialCode === input || pk === input;
      });

      setValue('country_code', matchedCountry ?? null);
      setValue('phone_type', formValues?.phone_type);

      if (formValues?.country?.pk !== '') {
        setValue('country', formValues?.country);
        setCountry(formValues?.country);
      }

      setValue(
        String(residenceAddressField?.id),
        formValues[String(residenceAddressField?.id)] ?? formValues?.residenceAddress
      );

      if (formValues?.city?.pk !== '') {
        setValue('city', {
          name: formValues?.city?.name,
          pk: formValues?.city?.pk
        });
        setCity({
          name: formValues?.city?.name,
          pk: formValues?.city?.pk
        });
      }
    }
    //get form 3
    if (nextPage === 3) {
      setSecondForm(true);
      // setCityDocument(formValues?.cityDocument);
      setValue('countryDocument', formValues?.countryDocument);
      setCountryDocument(formValues?.countryDocument);
      setValue('cityDocument', formValues?.cityDocument);
      if (formValues?.expeditionDate) {
        setValue(
          'expeditionDate',
          getformatedDateNoLetters(formValues?.expeditionDate, true) ?? null
        );
      }
      if (formValues?.documentType) setValue('documentType', formValues?.documentType);

      setValue('numberDocument', formValues?.numberDocument);
      if (fileName !== '') {
        const nameFileDoc = fileName;
        setActiveFileName(true);
        setFileName(nameFileDoc);
        setValue('documentFile', formValues?.documentFile);
      }
    }

    //get form 4
    if (nextPage === 4) {
      setValue(
        String(companyField?.id),
        formValues?.company ?? formValues[String(companyField?.id)]
      );
      setValue(
        String(positionField?.id),
        formValues?.position ?? formValues[String(positionField?.id)]
      );
      setValue('description', parameters?.TXT_REGISTATION?.value.replace('-', nameScheduler));

      setValue('is_educativeCredit', {
        value: formValues?.is_educativeCredit,
        label: formValues?.is_educativeCredit ? parameters?.INP_MSG_1?.value : 'No'
      });

      setUserRequiredCredit(formValues?.is_educativeCredit);
    }
  }, [nextPage, formValues, getCountryData]);

  function handleCountry(valor) {
    if (valor?.pk) {
      countryDocumentUser.current = valor?.pk;
      HttpClient.GET(API_DOCUMENT_TYPE_COUNTRIES, {
        country: valor.pk,
        component: COMPONENTS.COUNTRY,
        component_city: COMPONENTS.CITY
      }).then((data) => {
        setDocumentTypeList([]);
        if (data?.content) setDocumentTypeList(data?.content);
      });
    }
  }

  useEffect(() => {
    if (schedulerIdCourse > 0) {
      setIdScheduler(schedulerIdCourse);
      getNameScheduler(schedulerIdCourse);
    }
  }, [schedulerIdCourse]);

  //get name schedulers actives
  const getNameScheduler = (schedulerId) => {
    HttpClient.GET(API_GET_NAME_SCHEDULER, { schedulerId }).then((res) => {
      if (res.name_scheduler) setNameScheduler(res.name_scheduler);
    });
  };

  useEffect(() => {
    handleCountry(country?.pk);
  }, [getValues('country')]);

  // handle load
  const handleLoadFile = () => {
    const typeFile = inputFile?.current?.files?.[0]?.name.split('.').pop().toLowerCase();
    setErrorInvalidSize(false);
    if (typeFile === 'pdf') {
      if (inputFile.current.files[0].size < parseInt(parameters?.LIMIT_CV?.value ?? limitSize)) {
        setErrorInvalidSize(false);
        setErrorInvalidFile(false);
        setErrorEmptyFile(false);
        setFileName(inputFile.current.files[0].name);
        setTypeFile(typeFile);
        setActiveFileName(true);
        const reader = new FileReader();
        setLoadFile(true);
        reader.onload = (event) => {
          const base = ';base64,';
          const len = event.target.result.indexOf(base) + base.length;
          const f = event.target.result.substring(len);
          setLoadFile(false);
          setFile(f);
          setValue('');
        };

        reader.readAsDataURL(inputFile.current.files[0]);
        return;
      } else {
        setErrorInvalidSize(true);
        setActiveFileName(false);
        setErrorInvalidFile(false);
        setErrorEmptyFile(false);
        return;
      }
    } else {
      setErrorInvalidFile(true);
      setActiveFileName(false);

      setErrorEmptyFile(false);
      return;
    }
  };

  // remove the selected cv from the UI
  const removeResource = (evt) => {
    evt.preventDefault();
    setFileName('');
    setTypeFile('');
    setActiveFileName(false);
    setFile(null);
  };

  const isEducativeCredit = watch('is_educativeCredit');

  //select reference
  const handleCheckReference = (ref) => {
    const countryCode = alpha2codeCountries?.filter((phone) => phone.dial_code === ref?.dial_code);
    setFormValues({
      ...formValues,
      selectReference: ref?.id,
      system: ID_SYSTEM_INFORMATION.LMS,
      reference_type: ref?.reference_type?.pk,
      country_code_ref: countryCode?.[0]?.pk,
      phone_number_ref: ref?.phone_number,
      firstNameRef: ref?.first_name,
      lastNameRef: ref?.last_name,
      email: ref?.email
    });
    setCheckedRefs((prevCheckedRefs) =>
      prevCheckedRefs.map((checkedRef) => ({
        ...checkedRef,
        checked: checkedRef.id === ref?.id
      }))
    );
    setSelectedRef(ref);
  };

  const handleJobSubmit = (e) => {
    switch (nextPage) {
      case 1:
        handleJobSubmitFirstStep();
        break;
      case 2:
        handleSubmitSecondStep();
        break;
      case 3:
        handleSubmitThirtyStep();
        break;
      case 4:
        handleSubmitFourtyStep();
        break;
      case 5:
        handleSubmitFivetyStep();
        break;
      case 6:
        const dataTransform = transformData(formValues, variables);
        onSubmit(dataTransform, METHOD_ENROLLMENT.current);
        break;
      default:
        break;
    }
  };

  const METHOD_ENROLLMENT = useRef('POST');

  const handleValidationEnrollment = async (userId, schedulerId) => {
    const res = await HttpClient.GET(API_ENROLLMENT_VALIDATION_REGISTER, {
      userId,
      schedulerId,
      multilanguage_id: language
    });

    if (res.content) {
      METHOD_ENROLLMENT.current = 'PUT';
    }
    return res.content;
  };

  //submit Form 1
  const handleJobSubmitFirstStep = async () => {
    if (nameScheduler) {
      let valuesForm = getValues();
      let dataPayload = { ...formValues, ...valuesForm };
      dataPayload.schedulerId = idScheduler ?? parseInt(valuesForm?.schedulerId);
      dataPayload.multilanguage_id = language;
      dataPayload.emailUser = dataPayload?.email;
      setFormValues(dataPayload);
      sendCodeVerification(dataPayload);
    } else {
      setErrorSchedulerId(true);
    }
  };

  const sendCodeVerification = async (data, ref = false) => {
    const email = ref ? data.email_ref?.toLowerCase() : data.email?.toLowerCase();

    const res = await HttpClient.GET(API_REGISTER_USERS, {
      email: email,
      multilanguage_id: language,
      first_name: data?.first_name,
      last_name: data?.last_name,
      system: ID_SYSTEM_INFORMATION?.PORTAL
    });

    const userExist = res.content;

    if (userExist && !ref) {
      setUserId(res.content);
      setFormValues((prev) => ({ ...prev, userId: res.content, userExist }));
      setIsActiveModal(true);
    } else {
      setIsActiveModal(true);
    }
  };

  const onFinish = (dataRes) => {
    if (dataRes?.user_id && !isReference) {
      setUserId(dataRes?.user_id);
    }

    setIsActiveModal(false);
    if (isReference) {
      postReference({ ...formValues, code_verification: dataRes.code_verification });
    } else {
      handleLoadDataUser(dataRes);
    }
  };

  const handleLoadDataUser = (data) => {
    if (data.message === USER_CREATE) {
      setNextPage(2);
    }

    const valuesPersonalData = data?.personal_data?.content?.[0];
    const valuesUserPhone = data?.user_phone?.content;
    const valuesUserReference = data?.data_reference?.content;
    const dataVatiable = valuesPersonalData?.data_variables;
    const dataUserPhone = valuesUserPhone
      ? valuesUserPhone.find((phone) => Boolean(phone.is_main))
      : null;

    const position = dataVatiable?.find((vairable) => vairable.id === VARIABLES_ID.POSITION);
    const company = dataVatiable?.find((vairable) => vairable.id === VARIABLES_ID.COMPANY);
    const address = dataVatiable?.find((vairable) => vairable.id === VARIABLES_ID.ADDRESS);

    const countryUser = {
      name: valuesPersonalData?.country?.name,
      pk: valuesPersonalData?.country?.id
    };

    countryDocumentUser.current = countryUser?.pk;

    const cityUser = {
      name: valuesPersonalData?.city?.name,
      pk: valuesPersonalData?.city?.id
    };

    const phoneCode = alpha2codeCountries?.find(
      (phone) => phone.pk === dataUserPhone?.country_code_id
    );

    const phoneType = phoneTypeList?.find((phone) => phone.id === dataUserPhone?.phone_type);

    const valuesUserDocument = data?.user_document_type?.content?.[0];
    const countryDoc = countriesList.find(
      (country) => country.pk === valuesUserDocument?.info_country?.pk
    );

    const cityDocument = valuesUserDocument?.info_city?.pk;
    const documentType = {
      id: valuesUserDocument?.document_type_country_id,
      document_type: valuesUserDocument?.document_type_country_name
    };
    const numberDocument = valuesUserDocument?.number;
    const documentFile = valuesUserDocument?.document_file;
    const nameFileDoc = valuesUserDocument?.document_name;
    setCountry(countryUser);
    setCity(cityUser);
    setCountryDocument(countryDoc);

    if (documentFile) {
      setActiveFileName(true);
      setFileName(nameFileDoc);
    }

    if (valuesUserReference?.length > 0) {
      const listRefCheck = (valuesUserReference ?? []).map((ref) => {
        return {
          ...ref,
          checked: false
        };
      });

      setCheckedRefs(listRefCheck);
      setReferenceList(listRefCheck);
    }

    setFormValues({
      ...formValues,
      userId: data?.user_id ?? data?.userId,
      data_variables: valuesPersonalData?.data_variables,
      residenceAddress: address?.value,
      company: company?.value,
      position: position?.value,
      phone_type: phoneType,
      country_code: dataUserPhone?.country_code_id,
      phoneNumber: dataUserPhone?.number,
      country: countryUser,
      city: cityUser,
      countryDocument: countryDoc,
      cityDocument,
      expeditionDate: valuesUserDocument?.expedition_date
        ? getformatedDateNoLetters(valuesUserDocument?.expedition_date, true)
        : null,
      documentType,
      numberDocument,
      documentFile: null
    });

    setNextPage(2);
  };

  //Form 2
  const handleSubmitSecondStep = useCallback(() => {
    handleErrorsForm();
    const valuesForm = getValues();
    setFormValues((prevValues) => ({
      ...prevValues,
      ...valuesForm
    }));

    setNextPage(3);
  }, [getValues, formValues, setFormValues, setNextPage]);

  //Form 3
  const handleSubmitThirtyStep = () => {
    handleErrorsForm();
    setErrorEmptyFile(false);
    if (fileName === '') {
      setErrorEmptyFile(true);
      return;
    }
    const valuesForm = getValues();

    valuesForm.documentFile = file;
    valuesForm.code = typeFile;

    setFormValues((prevValues) => ({ ...prevValues, ...valuesForm }));

    setNextPage(4);
  };

  //Form 4
  const handleSubmitFourtyStep = async () => {
    if (!checkedTruthfulness && !getValues('is_educativeCredit')?.value) {
      setEmpyCheck(true);
      return;
    }
    setErrorSameReference({ show: false, message: null });
    const valuesForm = getValues();
    const dataPayload = { ...formValues, ...valuesForm };

    setFormValues((prevValues) => ({
      ...prevValues,
      ...dataPayload
    }));

    const user_enrollment_id = await handleValidationEnrollment(formValues.userId, idScheduler);

    if (user_enrollment_id) {
      dataPayload.user_enrollment_id = user_enrollment_id;
    }
    if (valuesForm?.is_educativeCredit?.value) {
      setNextPage(5);
    } else {
      dataPayload.is_educativeCredit = false;
      const dataSend = mapperDataEnrollment(dataPayload);
      const dataTransform = transformData(dataSend, variables);
      onSubmit(dataTransform, METHOD_ENROLLMENT.current);
    }
  };

  const handleSubmitFivetyStep = () => {

    if (!selectedRef && referenceList.length > 0) {
      // Buscamos la referencia completa que el usuario marcó.
      const refToEdit = referenceList.find(ref => ref.id === checkedReferenceId);

      // Si el usuario marcó una, vamos a editarla.
      // Si no marcó ninguna y dio "Siguiente", vamos al formulario de creación (objeto vacío).
      setSelectedRef(refToEdit || {});
      return; // Detenemos aquí, solo queríamos cambiar de vista.
    }
    const valuesForm = getValues();
    let dataPayload = { ...formValues, ...valuesForm, userId: userId };

    if (dataPayload?.email === dataPayload?.emailRef) {
      setErrorSameReference({ show: true, message: parameters?.USER_EMAIL_SOME_USER?.value });
      return;
    }

    // Asegurar que documentFileRef no se pierda si ya existía
    if (!valuesForm?.documentFileRef && formValues?.documentFileRef) {
      dataPayload.documentFileRef = formValues.documentFileRef;
      dataPayload.codeRef = formValues.codeRef;
    }

    if (!checkedTruthfulness) {
      setEmpyCheck(true);
      return;
    }

    dataPayload.is_truthfulness_confirmed = checkedTruthfulness;

    if (dataPayload?.selectReference && referenceList?.length > 0) {
      const dataPayloadSend = mapperDataEnrollment(dataPayload); // <-- usa documentFileRef
      const dataTransform = transformData(dataPayloadSend, variables);

      setFormValues((prevValues) => ({ ...prevValues, ...dataTransform }));
      onSubmit(dataTransform, METHOD_ENROLLMENT.current);
    } else {
      setFormValues((prevValues) => ({ ...prevValues, ...dataPayload }));
      setIsReference(true);
      const dataPayloadSend = mapperDataEnrollment(dataPayload); // <-- usa documentFileRef
      const dataTransform = transformData(dataPayloadSend, variables);
      setNameForm('');
      sendCodeVerification(dataTransform, true);
    }
  };

  const normalizeBoolean = (input) => {
    if (typeof input === 'boolean') return input;
    if (typeof input?.value === 'boolean') return input.value;
    if (typeof input?.value?.value === 'boolean') return input.value.value;
    return false; // valor por defecto si no se puede determinar
  };


  const mapperDataEnrollment = (valuesForm) => {
    const dataPayload = { ...formValues, ...valuesForm, userId: userId };
    //Form3

    dataPayload.is_truthfulness_confirmed = checkedTruthfulness

    dataPayload.country_code = dataPayload?.country_code?.pk
    dataPayload.country_code_ref = dataPayload?.country_code_ref?.pk
    dataPayload.city = dataPayload?.city?.pk
    dataPayload.country = dataPayload?.country?.pk
    dataPayload.system = ID_SYSTEM_INFORMATION.PORTAL
    dataPayload.country_document_type = dataPayload?.countryDocument?.pk
    dataPayload.city_document_type = dataPayload?.cityDocument?.pk
    dataPayload.countryDocumentRef = dataPayload?.countryDocumentRef?.pk
    dataPayload.cityDocumentRef = dataPayload?.cityDocumentRef?.pk
    dataPayload.documentType = dataPayload?.documentType?.id
    dataPayload.documentTypeRef = dataPayload?.documentTypeRef?.id
    dataPayload.code = 'pdf';
    dataPayload.phone_type = dataPayload?.phone_type?.id
    dataPayload.emailRef = dataPayload?.email_ref
    dataPayload.is_educativeCredit = normalizeBoolean(dataPayload.is_educativeCredit);
    dataPayload.referenceType = dataPayload?.referenceType?.pk



    return dataPayload;
  };

  const postReference = (data) => {
    const dataPayLoad = {
      ...data
    };
    delete dataPayLoad.firstNameRef;
    delete dataPayLoad.lastNameRef;
    delete dataPayLoad.cityDocument;
    delete dataPayLoad.countryDocument;
    delete dataPayLoad.email_ref;
    delete dataPayLoad.referenceType;
    setIsReference(false);
    const dataSend = mapperDataEnrollment(dataPayLoad);
    const dataTransform = transformData(dataSend, variables);

    onSubmit(dataTransform, METHOD_ENROLLMENT.current);
  };

  //TODO: REFACTOR modular components
  //step 1 Datos personales
  const firstStep = () => {
    setNameForm(parameters?.TXT_DOC_PRF?.value);
    return (
      <>
        {errorSchedulerId && (
          <InfoErrorCode color="black" message={parameters?.TXT_ID_SCH?.value} />
        )}
        <Row >
          <p className="text-black bold">
            {nameForm}
          </p>
          <Col lg={12} >
            <label className="description-label" htmlFor="first_name">
              {watch('first_name') && parameters?.INF_MSG_156?.value}
            </label>
            <InputFormControl
              name="first_name"
              type="text"
              rules={{
                required: parameters?.RQD_MSG_8?.value || (
                  <Spinner backgroundColor="black"></Spinner>
                )
              }}
              control={control}
              placeholder={parameters?.INF_MSG_156?.value}
              error={errors?.first_name}
              border
              customHeight="2.5rem"
            />
          </Col>
          <Col lg={12} >
            <label className="description-label" htmlFor="last_name">
              {watch('last_name') && parameters?.MSG_INF_158?.value}
            </label>
            <InputFormControl
              name="last_name"
              type="text"
              rules={{
                required: parameters?.RQD_MSG_8?.value || (
                  <Spinner backgroundColor="black"></Spinner>
                )
              }}
              control={control}
              placeholder={parameters?.MSG_INF_158?.value}
              error={errors?.last_name}
              border
              customHeight="2.5rem"
            />
          </Col>
          <Col lg={12} >
            <label className="description-label" htmlFor="Email">
              {watch('email') && parameters?.CREATE_ACCOUNT_EMAIL?.value}
            </label>

            <InputFormControl
              name="email"
              control={control}
              type="email"
              rules={{
                required: parameters?.RQD_MSG_8?.value || 'El campo de correo es requerido.',
                pattern: {
                  value:
                    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message: 'Correo inválido.'
                }
              }}
              placeholder={parameters?.CREATE_ACCOUNT_EMAIL?.value}
              error={errors?.email}
              border
              customHeight="2.5rem"
            />
          </Col>
        </Row>
      </>
    );
  };

  //step 2 Pais, ciudad, residencia
  const secondStep = () => {
    setNameForm(residenceAddressField?.name);
    return (
      <>
        {' '}
        <Row>
          <p className="text-black bold">
            {nameForm}
          </p>
          <Col lg={12}>
            <Form.Group controlId="country">
              <label className="description-label" htmlFor="country">
                {(watch('country')?.pk || watch('country')?.id) &&
                  parameters?.RESIDENCE_COUNTRY?.value}
              </label>
              <SpinnerMiddleware targetParameter={parameters?.RESIDENCE_COUNTRY}>
                <Controller
                  aria-label="country list controller"
                  render={(props) => (
                    <Select
                      aria-label="country selector"
                      {...props}
                      cacheOptions
                      options={countriesList}
                      placeholder={parameters?.RESIDENCE_COUNTRY?.value}
                      ref={register}
                      getOptionValue={(option) => option.pk}
                      getOptionLabel={(option) => option.name}
                      styles={selectCustomStyles}
                      className="is-invalid"
                      onChange={(val) => {
                        setCountry(val);
                        handleCountry(val);
                        clearErrors('country');
                      }}
                      value={getValues('country')?.pk ? getValues('country') : null}
                      selectStyles={selectStyles}
                    />
                  )}
                  control={control}
                  name="country"
                  rules={{
                    required: parameters?.RQD_MSG_8?.value
                  }}
                />
              </SpinnerMiddleware>

              {errors.country?.message?.length > 0 && (
                <Form.Control.Feedback type="invalid">
                  {errors.country.message || parameters?.RQD_MSG_8?.value}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group controlId="city">
              <label className="description-label" htmlFor="city">
                {(watch('city')?.pk || watch('city')?.id) && parameters?.RESIDENCE_CITY?.value}
              </label>
              <SpinnerMiddleware targetParameter={parameters?.INF_MSG_189}>
                <Controller
                  aria-label="city list controller"
                  render={({ field }) => (
                    <Select
                      aria-label="city selector"
                      {...field}
                      cacheOptions
                      options={citiesList}
                      placeholder={parameters?.RESIDENCE_CITY?.value}
                      ref={register}
                      getOptionValue={(option) => option.pk}
                      getOptionLabel={(option) => option.name}
                      styles={selectCustomStyles}
                      isDisabled={!getValues('country')}
                      className="is-invalid"
                      onChange={(val) => {
                        setCity(val);
                        clearErrors('city');
                      }}
                      value={city?.pk ? city : null}
                      selectStyles={selectStyles}
                    />
                  )}
                  control={control}
                  name="city"
                  rules={{
                    required: parameters?.RQD_MSG_8?.value
                  }}
                />
              </SpinnerMiddleware>

              {errors?.city?.message?.length > 0 && (
                <Form.Control.Feedback type="invalid">
                  {errors?.city?.message || parameters?.RQD_MSG_8?.value}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col>
          {residenceAddressField && (
            <Col lg={12}>
              <Form.Group controlId={residenceAddressField?.id}>
                <label className="description-label" htmlFor={residenceAddressField?.name}>
                  {watch(String(residenceAddressField?.id))?.length > 0 &&
                    residenceAddressField?.name}
                </label>

                <InputFormControl
                  name={String(residenceAddressField?.id)}
                  value={getValues(String(residenceAddressField?.id))}
                  type={residenceAddressField?.widget_type_id === 1 ? 'text' : 'number'}
                  rules={{
                    required: residenceAddressField?.is_mandatory
                      ? parameters?.RQD_MSG_8?.value
                      : null
                  }}
                  control={control}
                  placeholder={parameters?.LBL_ADDRESS?.value}
                  error={errors[residenceAddressField?.id]}
                  border
                  customHeight="2.5rem"
                />
              </Form.Group>
            </Col>
          )}
          <Col lg={12}>
            <Form.Group >
              <div className="row" style={{ alignItems: 'flex-end' }}>
                <Col xs={12} lg={12}>
                  <label className="description-label" htmlFor="phone_type">
                    {(watch('phone_type')?.pk || watch('phone_type')?.id) &&
                      parameters?.PHONE_TYPE_LABEL?.value}
                  </label>
                  <SelectFormControl
                    name="phone_type"
                    control={control}
                    options={phoneTypeList}
                    nameOptionValue="pk"
                    rules={{
                      required: parameters?.RQD_MSG_3?.value || 'El campo es requerido.'
                    }}
                    error={errors?.phone_type}
                    renderOptionLabel={(option) => option.name}
                    placeholder={parameters?.PHONE_TYPE_LABEL?.value}
                    selectStyles={selectStyles}
                  />
                </Col>
                <Col xs={6} lg={5} className="mt-2">
                  <label className="description-label" htmlFor="country_code">
                    {(watch('country_code')?.pk || watch('country_code')?.pk) &&
                      parameters?.MSG_INF_160?.value}
                  </label>
                  <SelectFormControl
                    name="country_code"
                    control={control}
                    options={alpha2codeCountries.filter((country) => country.dial_code != null)}
                    nameOptionValue="abbreviation_name"
                    rules={{
                      required: parameters?.RQD_MSG_8?.value || 'El campo es requerido.'
                    }}
                    error={errors?.country_code}
                    renderOptionLabel={(option) => (
                      <>
                        <img
                          src={`${option?.flag}`}
                          alt="Country flag"
                          style={{ width: 20, marginRight: 5 }}
                        />
                        {`${option?.abbreviation_name} ${option?.dial_code}`.toUpperCase()}
                      </>
                    )}
                    placeholder={parameters?.PH_MSG_3?.value}
                    selectStyles={selectStyles}
                    value={countryPhoneNumberValue}
                  />
                </Col>
                <Col xs={6} lg={7} className="pl-0">
                  <label className="description-label" htmlFor="phoneNumber">
                    {watch('phoneNumber') !== ''}
                  </label>

                  <InputFormControl
                    border
                    borderRadius="5px"
                    customHeight="2.5rem"
                    name="phoneNumber"
                    control={control}
                    type="number"
                    rules={{
                      required: parameters?.RQD_MSG_8?.value || 'El campo es requerido',
                      maxLength: {
                        value: 11,
                        message: parameters?.TXT_ERR_PHONE?.value
                      },
                      pattern: {
                        value: /^[0-9]+$/,

                        message: parameters?.ERR_MSG_3?.value || 'Únicamente números'
                      }
                    }}
                    placeholder={parameters?.MSG_INF_161?.value}
                    error={errors?.phoneNumber}
                  />
                </Col>
              </div>
            </Form.Group>
          </Col>
        </Row>
      </>
    );
  };

  //step 3 typeDocument, #document, date expedition, document, company_user
  const thirtyStep = () => {
    setNameForm(parameters?.TITLE_FORM_INSCRIPTION_DOC?.value);
    return (
      <Row>
        <p className="text-black bold">
          {nameForm}
        </p>
        <Col lg={12}>
          <Form.Group controlId="countryDocument">
            <label className="description-label" htmlFor="countryDocument">
              {(watch('countryDocument')?.pk || watch('countryDocument')?.id) &&
                parameters?.EXPEDITIONS_COUNTRY?.value}
            </label>
            <SpinnerMiddleware targetParameter={parameters?.EXPEDITIONS_COUNTRY}>
              <Controller
                aria-label="countryDocument list controller"
                render={({ field }) => (
                  <Select
                    aria-label="countryDocument selector"
                    {...field}
                    cacheOptions
                    options={countriesList}
                    placeholder={parameters?.EXPEDITIONS_COUNTRY?.value || 'Selecciona un país'}
                    getOptionValue={(option) => option.pk}
                    getOptionLabel={(option) => option.name}
                    styles={selectCustomStyles}
                    className="is-invalid"
                    onChange={(val) => {
                      setCountryDocument(val);
                      handleCountry(val);
                    }}
                    value={getValues('countryDocument')}
                  />
                )}
                control={control}
                name="countryDocument"
                rules={{
                  required: parameters?.RQD_MSG_8?.value
                }}
              />
            </SpinnerMiddleware>

            {errors.countryDocument?.message?.length > 0 && (
              <Form.Control.Feedback type="invalid">
                {errors.countryDocument.message || parameters?.RQD_MSG_8?.value}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
        <Col lg={12}>
          <Form.Group controlId="cityDocument">
            <label className="description-label" htmlFor="cityDocument">
              {(watch('cityDocument')?.pk || watch('cityDocument')?.id) &&
                parameters?.EXPEDITIONS_CITY?.value}
            </label>
            <SpinnerMiddleware targetParameter={parameters?.EXPEDITIONS_CITY}>
              <Controller
                aria-label="cityDocument list controller"
                render={({ field }) => (
                  <Select
                    aria-label="cityDocument selector"
                    {...field}
                    cacheOptions
                    options={citiesListDoc}
                    placeholder={
                      parameters?.EXPEDITIONS_CITY?.value || 'Selecciona un tipo de documento'
                    }
                    ref={register}
                    getOptionValue={(option) => option.pk}
                    getOptionLabel={(option) => option.name}
                    styles={selectCustomStyles}
                    isDisabled={!countryDocumentUser.current}
                    className="is-invalid"
                    onChange={(val) => setCityDocument(val)}
                    value={getValues('cityDocument')}
                  />
                )}
                control={control}
                name="cityDocument"
                rules={{
                  required: parameters?.RQD_MSG_8?.value
                }}
              />
            </SpinnerMiddleware>

            {errors.cityDocument?.message?.length > 0 && (
              <Form.Control.Feedback type="invalid">
                {errors.cityDocument.message || parameters?.RQD_MSG_8?.value}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        <Col lg={12}>
          <Form.Group controlId="documentType">
            <label className="description-label" htmlFor="documentType">
              {(watch('documentType')?.pk || watch('documentType')?.id) &&
                parameters?.LBL_TYPE_DOC?.value}
            </label>
            <SpinnerMiddleware targetParameter={parameters?.EXPEDITIONS_COUNTRY}>
              <Controller
                aria-label="documentType list controller"
                render={(props) => (
                  <Select
                    aria-label="documentType selector"
                    {...props}
                    cacheOptions
                    options={documentTypeList}
                    placeholder={parameters?.LBL_TYPE_DOC?.description_value}
                    ref={register}
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.document_type}
                    isDisabled={!getValues('cityDocument')}
                    styles={selectCustomStyles}
                    className="is-invalid"
                    onChange={(val) => {
                      setValue('documentType', val);
                      clearErrors('documentType');
                      setDocumentType(val);
                    }}
                    value={
                      getValues('documentType')?.pk || getValues('documentType')?.id
                        ? getValues('documentType')
                        : null
                    }
                  />
                )}
                control={control}
                name="documentType"
                rules={{
                  required: parameters?.RQD_MSG_8?.value
                }}
              />
            </SpinnerMiddleware>

            {errors.documentType?.message?.length > 0 && (
              <Form.Control.Feedback type="invalid">
                {errors.documentType.message || parameters?.RQD_MSG_8?.value}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        <Col lg={12}>
          <Form.Group className=" mb-2" controlId="numberDocument">
            <SpinnerMiddleware targetParameter={'parameters?.INF_MSG_156'}>
              <label className="description-label" htmlFor="numberDocument">
                {watch('numberDocument')?.length > 0 && parameters?.LBL_NUMBER_DOC?.value}
              </label>
            </SpinnerMiddleware>
            <InputFormControl
              name="numberDocument"
              type="text"
              rules={{
                required: parameters?.RQD_MSG_8?.value || (
                  <Spinner backgroundColor="black"></Spinner>
                )
              }}
              control={control}
              placeholder={parameters?.LBL_NUMBER_DOC?.value}
              error={errors?.numberDocument}
              border
              customHeight="2.5rem"
            />
          </Form.Group>
        </Col>
        <Col lg={12}>
          <Form.Group controlId="expeditionDate">
            <label className="description-label" htmlFor="expeditionDate">
              {parameters?.LBL_EXP_DATE?.value}
            </label>
            <InputFormControl
              name="expeditionDate"
              type="date"
              control={control}
              placeholder={parameters?.LBL_EXP_DATE?.value}
              error={errors?.expeditionDate}
              border
              rules={{
                required: parameters?.RQD_MSG_8?.value || (
                  <Spinner backgroundColor="black"></Spinner>
                )
              }}
              customHeight="2.5rem"
              defaultValue={getValues('expeditionDate')}
              value={getValues('expeditionDate')}
            />
          </Form.Group>
        </Col>
        <Col lg={12} className="py-3">
          <Form.Group controlId="documentFile">
            {watch('documentFile') !== '0' && (
              <label className="description-label" htmlFor="documentFile">
                {parameters?.LBL_DOC_FILE?.value}
              </label>
            )}
            <label
              className="d-flex mt-3 w-100 justify-content-between cv-container"
              style={{
                borderBottom: '1px solid #ddd',
                paddingBottom: '8px',
                boder: '1px'
              }}>
              {activeFileName ? (
                <span
                  style={{
                    width: 'inherit',
                    textOverflow: 'ellipsis',
                    marginRight: '15px'
                  }}>
                  {fileName}
                </span>
              ) : (
                <span style={{ color: '#aaa', marginLeft: '10px' }}>
                  {parameters?.UPLOAD_DOC?.value}
                </span>
              )}
              <input
                style={{ display: 'none' }}
                type="file"
                id="documentFile"
                name="documentFile"
                accept=".pdf"
                ref={inputFile}
                onChange={() => handleLoadFile('documentFile')}
              />
              {fileName?.length > 0 ? (
                <FontAwesomeIcon
                  className="cirlce-xmark"
                  icon={faCircleXmark}
                  onClick={removeResource}
                />
              ) : (
                <FontAwesomeIcon icon={faEllipsis} />
              )}
            </label>
            {errorInvalidFile && (
              <span className="label-inputs-required text-danger">
                {parameters?.ERR_MSG_9?.value || 'Debe cargar un archivo .pdf'}
              </span>
            )}
            {errorInvalidSize && (
              <MessageError
                message={`${parameters?.ERR_MSG_10?.value} ${DIV_LIMIT_FILE.limit_mb / DIV_LIMIT_FILE.divisor
                  } MB`}
              />
            )}
            {errorEmptyFile && <MessageError message={parameters?.RQD_MSG_8?.value} />}
          </Form.Group>
        </Col>
      </Row>
    );
  };

  // step 4 posiotion, intetrest, credit
  const cuarterStep = () => {
    setNameForm(parameters?.TITLE_FORM_INSCRIPTION_PROFESIONAL?.value);
    return (
      <Row>
        <p className="text-black bold">
          {nameForm}
        </p>
        {companyField && (
          <Col lg={12}>
            <Form.Group className="mb-3" controlId={companyField?.id}>
              <label className="description-label" htmlFor={companyField?.name}>
                {watch(String(companyField?.id))?.length > 0 && companyField?.name}
              </label>

              <InputFormControl
                name={String(companyField?.id)}
                type={companyField?.widget_type_id === 1 ? 'text' : 'number'}
                control={control}
                placeholder={companyField?.name}
                error={errors[companyField?.id]}
                rules={{
                  required: companyField?.is_mandatory ? parameters?.RQD_MSG_8?.value : null
                }}
                border
                customHeight="2.5rem"
              />
            </Form.Group>
          </Col>
        )}
        {positionField && (
          <Col lg={12}>
            <Form.Group controlId={positionField?.id}>
              <label className="description-label" htmlFor={positionField?.name}>
                {watch(String(positionField?.id))?.length > 0 && positionField?.name}
              </label>

              <InputFormControl
                name={String(positionField?.id)}
                value={getValues('position')}
                type="text"
                control={control}
                placeholder={positionField?.name}
                rules={{
                  required: positionField?.is_mandatory
                    ? parameters?.RQD_MSG_8?.value || <Spinner backgroundColor="black"></Spinner>
                    : null
                }}
                error={errors?.[positionField?.id]}
                border
                customHeight="2.5rem"
              />
            </Form.Group>
          </Col>
        )}
        <Col lg={12} className="py-3">
          <Form.Group controlId="description">
            <label className="description-label" htmlFor="description">
              {watch('description') && parameters?.LBL_DESC_SERV?.value}
            </label>
            <SpinnerMiddleware targetParameter={'parameters?.INF_MSG_193'}>
              <Controller
                aria-label="interest program controller"
                render={(props) => (
                  <Form.Control
                    {...props}
                    value={getValues('description')}
                    as="textarea"
                    ref={register}
                    rows={4}
                  />
                )}
                control={control}
                name="description"
                rules={{
                  message: parameters?.RQD_MSG_8?.value,
                  required: parameters?.RQD_MSG_8?.value
                }}
              />
            </SpinnerMiddleware>

            {errors.description && (
              <Form.Control.Feedback type="invalid">
                {errors?.description?.message || parameters?.RQD_MSG_8?.value}
              </Form.Control.Feedback>
            )}
            {errors.description && <MessageError message={errors?.description?.message} />}
          </Form.Group>
        </Col>
        <Col lg={12}>
          <label className="description-label" htmlFor="SchedulerMembershipPrice">
            {watch('SchedulerMembershipPrice') && parameters?.MEMBERSHI_LIST?.value}
          </label>


          <SelectFormControl
            name="SchedulerMembershipPrice"
            control={control}
            options={membershiList}
            renderOptionLabel={(option) => (
              <>{`${option?.name}`}</>
            )}
            placeholder={parameters?.MEMBERSHI_LIST?.value}
            selectStyles={selectStyles}
            onChange={(value) => {
              setValue('SchedulerMembershipPrice', value, { shouldValidate: true });
            }}
            nameOptionValue="id"
          />

        </Col>
        <Col lg={12} className="py-3">
          <Form.Group controlId="is_educativeCredit">
            <label className="description-label" htmlFor="is_educativeCredit">
              {watch('is_educativeCredit')?.label !== '' && parameters?.LBL_REQ_CREDIT?.value}
            </label>
            <SpinnerMiddleware targetParameter={'parameters?.MSG_INF_159'}>
              <Controller
                aria-label="is_educativeCredit controller"
                render={(props) => (
                  <Select
                    {...props}
                    value={getValues('is_educativeCredit')}
                    type="text"
                    ref={register}
                    placeholder={parameters?.LBL_REQ_CREDIT?.value}
                    isInvalid={!!errors.is_educativeCredit}
                    options={[
                      { value: true, label: parameters?.INP_MSG_1?.value },
                      { value: false, label: 'No' }
                    ]}
                    styles={selectCustomStyles}
                  />
                )}
                control={control}
                name="is_educativeCredit"
                rules={{
                  required: parameters?.RQD_MSG_8?.value
                }}
              />
            </SpinnerMiddleware>
            {errors.is_educativeCredit && (
              <MessageError message={errors?.is_educativeCredit?.message} />
            )}
          </Form.Group>
        </Col>
        {!getValues('is_educativeCredit')?.value && (
          <>
            <div className="pt-2">
              <CustomCheck
                onChange={() => handleCheck(!checkedTruthfulness)}
                checked={checkedTruthfulness}
                description="Declaro que la información proporcionada es verdadera y correcta."
              />
            </div>
            {empyCheck && (
              <MessageError
                message={parameters?.ERR_MSG_5?.description_value ?? 'El campo requerido'}
              />
            )}
          </>
        )}
      </Row>
    );
  };

  // step 5 referencias
  const fiveStep = () => {

    return (
      <div className="jobs-form" style={{ maxHeight: '25rem' }}>
        {selectedRef ? (
          <ReferenceForm
            parameters={parameters}
            control={control}
            errors={errors}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            register={register}
            setFormValues={setFormValues}
            selectStyles={selectStyles}
            referenceTypeList={referenceTypeList}
            checkedTruthfulness={checkedTruthfulness}
            handleCheck={handleCheck}
            empyCheck={empyCheck}
            errorSameReference={errorSameReference}
            nameForm={nameForm}
            setNameForm={setNameForm}
            defaultValues={{
              firstNameRef: selectedRef.first_name,
              lastNameRef: selectedRef.last_name,
              email_ref: selectedRef.email,
              phone_type_ref: selectedRef.phone_type_id,
              phone_number_ref: selectedRef.phone_number,
              country_code_ref: selectedRef.dial_code,
              referenceType: selectedRef.reference_type
            }}
          />
        ) : referenceList?.length > 0 ? (
          <ReferenceTable
            referenceList={referenceList}
            parameters={parameters}
            control={control}
            errors={errors}
            checkedReferenceId={checkedReferenceId} // Pasamos el ID seleccionado
            handleReferenceSelection={handleReferenceSelection} // Pasamos la nueva función
            checkedTruthfulness={checkedTruthfulness}
            handleCheck={handleCheck}
            empyCheck={empyCheck}
            nameForm={nameForm}
            setNameForm={setNameForm}
          />
        ) : (
          <ReferenceForm
            parameters={parameters}
            control={control}
            errors={errors}
            watch={watch}
            getValues={getValues}
            setValue={setValue}
            register={register}
            setFormValues={setFormValues}
            selectStyles={selectStyles}
            referenceTypeList={referenceTypeList}
            checkedTruthfulness={checkedTruthfulness}
            handleCheck={handleCheck}
            empyCheck={empyCheck}
            errorSameReference={errorSameReference}
            nameForm={nameForm}
            setNameForm={setNameForm}
          />
        )}
      </div>
    );
  };

  const handleCheck = (check) => {
    setEmpyCheck(false);
    // setFormValues({ ...formValues, is_truthfulness_confirmed: check });
    setCheckedTruthfulness(check);
  };

  return isActiveModal ? (
    <div style={{ margin: window.innerWidth < 600 ? '0 20px' : '0 60px' }}>
      <AccountVerification
        showTitle
        isPortal={isReference ? false : true}
        isReference={isReference}
        email={isReference ? formValues?.email_ref : formValues?.email}
        onCloseModal={setIsActiveModal}
        onReturn={handleDataForm}
        onFinish={onFinish}
        dataPayload={
          isReference
            ? {
              ...formValues,
              firstName: formValues?.firstNameRef,
              lastName: formValues?.lastNameRef
            }
            : formValues
        }
      />
    </div>
  ) : (
    <Form className="jobs-form text-start d-flex flex-column" onSubmit={handleSubmit(handleJobSubmit)}>
      <LoadingOverlay
        active={loadFile}
        spinner
        text="Cargando..."
        styles={{
          wrapper: {
            flex: '1 1 auto', // Permite que el overlay se estire
            display: 'flex',
            flexDirection: 'column',
          }
        }}
      >
        <div className="container " style={{ flex: '1 1 auto', overflowY: 'auto', padding: nextPage === 4 ? '1rem 1.5rem 1rem' : '0 1.5rem 1rem' }}>
          {messageError !== '' && <InfoErrorCode color="black" message={messageError} />}
          {nextPage === 1
            ? firstStep()
            : nextPage === 2
              ? secondStep()
              : nextPage === 3
                ? thirtyStep()
                : nextPage === 4
                  ? cuarterStep()
                  : fiveStep()}
        </div>
        <div
          className="d-flex justify-content-center align-items-center gap-3 p-3 mt-auto"
          style={{
            backgroundColor: 'rgba(255, 233, 0, 0.05)',
          }}
        >
          <input
            type="submit"
            value={
              (nextPage === 4 && isEducativeCredit?.value === false) ||
                (nextPage === 5 && (referenceList.length === 0 || selectedRef)) ||
                nextPage > 5
                ? parameters?.TXT_SEND?.value ?? 'Enviar'
                : parameters?.TXT_SEND?.description_value ?? 'Siguiente'
            }
            className="btn btn-block yellow"
            style={{ border: 'none', width: '35%', margin: '0px' }}
          />
          {nextPage !== 1 && (
            <input
              type="button"
              value={parameters?.INF_MSG_51?.value}
              className="btn btn-outline-black"
              style={{ width: '35%', margin: '0px' }}
              onClick={() => {
                setSelectedRef(null);
                setCheckedRefs([]);
                setNextPage(nextPage - 1);
                if (nextPage - 1 === 1 && onSchedulerSelect) {
                  onSchedulerSelect(null);
                }
              }}
            />
          )}

        </div>
      </LoadingOverlay>
    </Form>
  );
};
